<template>
  <input
    ref="input"
    type="text"
    class="form-control"
    data-ub-tag-variant="primary"
    :placeholder="t('placeholder')"
    :value="props.initialValue"
  />
</template>

<i18n lang="yaml">
en:
  placeholder: 'Type and press Enter to add a tag'
ru:
  placeholder: 'Введите и нажмите Enter, чтобы добавить тег'
</i18n>

<script setup lang="ts">
import UseBootstrapTag from 'use-bootstrap-tag'
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const props = defineProps({
  initialValue: {
    type: Array<String>,
    default: []
  }
})

const input = ref<HTMLInputElement>()
const useBootstrapTag = ref()

onMounted(() => {
  useBootstrapTag.value = UseBootstrapTag(input.value!!)
})
</script>
